import { Directive } from '@angular/core';

@Directive({
    selector: '[pItemListActionsDef]',
})
export class ItemListActionsDefDirective {}
